module.exports = __webpack_public_path__ + "img/cardano.c3cae762.png";